
    import './styles.scoped.css';
    export default {
  "root": "awsui_root_12hwc_16h1p_7",
  "layout-strut": "awsui_layout-strut_12hwc_16h1p_11",
  "list-bottom": "awsui_list-bottom_12hwc_16h1p_17"
};
  